var _ellipse, _ellipse2, _g, _defs;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgBtn1(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 75,
    height: 49,
    viewBox: "0 0 75 49",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _ellipse || (_ellipse = /*#__PURE__*/React.createElement("ellipse", {
    cx: 37.8088,
    cy: 24.56,
    rx: 37.1912,
    ry: 24.4399,
    fill: "url(#paint0_linear_1833_3254)"
  })), _ellipse2 || (_ellipse2 = /*#__PURE__*/React.createElement("ellipse", {
    cx: 37.8393,
    cy: 18.4266,
    rx: 33.8393,
    ry: 18.3065,
    fill: "url(#paint1_linear_1833_3254)"
  })), _g || (_g = /*#__PURE__*/React.createElement("g", {
    filter: "url(#filter0_i_1833_3254)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M36.4971 16.1021H33.9609L32.2998 19.2466H32.2041L30.5293 16.1021H27.8769L30.6592 20.7368L27.8701 25.4331H30.29L32.0537 22.3706H32.1494L33.9131 25.4331H36.4629L33.5986 20.7642L36.4971 16.1021ZM44.8398 25.4331V9.43701H41.0547C39.8008 10.2222 38.4648 11.0776 37.2344 11.9448V15.355C38.3828 14.5581 39.7891 13.6558 40.8437 12.9644H41.0078V25.4331H44.8398Z",
    fill: "#623B00"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("filter", {
    id: "filter0_i_1833_3254",
    x: 27.8701,
    y: 9.43701,
    width: 17.9697,
    height: 16.9961,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "BackgroundImageFix",
    result: "shape"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceAlpha",
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
    result: "hardAlpha"
  }), /*#__PURE__*/React.createElement("feOffset", {
    dx: 1,
    dy: 1
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 0.5
  }), /*#__PURE__*/React.createElement("feComposite", {
    in2: "hardAlpha",
    operator: "arithmetic",
    k2: -1,
    k3: 1
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0.25 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in2: "shape",
    result: "effect1_innerShadow_1833_3254"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint0_linear_1833_3254",
    x1: 37.8088,
    y1: 0.120117,
    x2: 37.8088,
    y2: 48.9999,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FFAD31"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.0001,
    stopColor: "#FFA825"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#BB6313"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint1_linear_1833_3254",
    x1: 20.3853,
    y1: 3.78142,
    x2: 32.3824,
    y2: 41.2925,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FEB82F"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#FE922F"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgBtn1);
export default __webpack_public_path__ + "static/media/btn1.fb11ba18ead234664cf8f7e144caeedc.svg";
export { ForwardRef as ReactComponent };